import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './global-styles/base-style.scss';
import './global-styles/antd-custom.scss';
import './global-styles/light-theme.scss';
import './global-styles/admin.scss';
import './global-styles/admin-lightTheme.scss';
import './global-styles/equipments-history-modal-overrides.css';
import './components/Materials/MaterialsModal.css';
import './global-styles/antd-select-dropdown-portal.scss';
import './global-styles/login.scss';

import 'ag-grid-enterprise';
import { LicenseManager } from '@ag-grid-enterprise/core';
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_ENTERPRISE_LICENSE);

// Suppress known browser/dev-overlay ResizeObserver noise (non-actionable, UI remains functional).
if (typeof window !== 'undefined') {
  const resizeObserverMessages = new Set([
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ]);

  window.addEventListener('error', (event) => {
    if (resizeObserverMessages.has(event?.message)) {
      event.stopImmediatePropagation();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
/* StrictMode disabled: it double-invokes effects in dev and duplicates every mount-time API call. */
root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
